import React from "react";
import { IconFolder, IconOptions } from "../../../icons/Icon";
import SmuButton from "../../../utils/smu-button/SmuButton";
import SmuSkirt from "../../../utils/smu-skirt/SmuSkirt";
import { COLOR_PRIMARY } from "../../../constants/colors";

const SkirtItem = ({
  depth,
  isOpen,
  onToggle,
  node,
  hasChild,
  active,
  choseSkirt,
}) => {
  return (
    <SmuSkirt
      style={{ marginLeft: depth * 10 }}
      onToggle={onToggle}
      positionToggle="left"
      isOpen={isOpen}
      hasChild={hasChild}
      openClickInIndicator={true}
      controls={
        <SmuButton _className="load-control">
          <IconOptions color="#748A9D" />
        </SmuButton>
      }
    >
      <div
        className="my-auto d-flex align-items-center w-100"
        onClick={() => choseSkirt(node)}
        style={{ cursor: "pointer" }}
        // Old version:
        // onClick={() => choseSkirt(node)}
      >
        <div className="square-folder">
          <IconFolder color={active ? COLOR_PRIMARY : "#FEB92B"} />
          {/* Old version: */}
          {/* <IconFolder color="#FEB92B" /> */}
        </div>
        <div className={`ms-2 folder-name text-truncate ${active && "active"}`}>
          {node.title} - {node.abb}
        </div>
        {/* Old version: */}
        {/*<div className="ms-2 folder-name text-truncate">*/}
        {/*  {node.title} - {node.abb}*/}
        {/*</div>*/}
      </div>
    </SmuSkirt>
  );
};

export default SkirtItem;
